import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import ContactLink from './ContactLink';

const { Link, Links } = deriveLinkComponents(ContactLink, api.getContact);

export { Link as ContactLink, Links as ContactLinks };
